import React, { useCallback, useRef, useState } from 'react';
import ConfirmDialog from '../../../ui/ConfirmDialog';

/**
 * Führt Einträge aus `utils/cardActions.js` aus und fragt bei Einträgen mit `confirm` vorher nach.
 *
 *   const { select, dialog } = useActionConfirm();
 *   <button onClick={() => select(entry)} />  …  {dialog}
 *
 * - `select(entry)`: ohne `entry.confirm` sofort `entry.onSelect()`, sonst öffnet `dialog` einen
 *   `ConfirmDialog` (Ton „danger") mit `confirm.title`, `confirm.description` und
 *   `confirm.confirmLabel`; erst „Bestätigen" ruft `onSelect`.
 * - `dialog` muss der Aufrufer rendern. Der zuletzt gezeigte Text bleibt während der
 *   Schließ-Animation stehen.
 */
export function useActionConfirm() {
  const [pending, setPending] = useState(null);
  const lastShownRef = useRef(null);
  if (pending) lastShownRef.current = pending;
  const shown = lastShownRef.current?.confirm || {};

  const select = useCallback((entry) => {
    if (entry.confirm) setPending(entry);
    else entry.onSelect?.();
  }, []);

  const dialog = (
    <ConfirmDialog
      open={!!pending}
      onOpenChange={(open) => { if (!open) setPending(null); }}
      title={shown.title}
      description={shown.description}
      confirmLabel={shown.confirmLabel}
      tone="danger"
      onConfirm={() => {
        const entry = pending;
        setPending(null);
        entry?.onSelect?.();
      }}
    />
  );

  return { select, dialog };
}
